

<div  *ngIf="isLoading||anyViewLoaderEnable" id="overlay" >
  <!-- <div  class="loader-wrapper">
    <span class="spinner-loader-new spinner-border"></span>
    <img class="spinner-loader-img"  src='assets/img/GCU-logo.svg' />
  </div>  -->
  <div *ngIf="isLoading||anyViewLoaderEnable" id="overlay">
    <div id="loader-wrapper">
      <div id="loader"></div>
    </div>
  </div>
</div>


 <!-- <div class="row">
  <div class="col-md-4 d-flex justify-content-center align-items-center">
  <mat-form-field appearance="none">
    <mat-select (selectionChange)="onChange()"  [(value)]="selected">
      <mat-option value="enStyleSheet">Custom 1</mat-option>
      <mat-option value="en2StyleSheet">Custom 2</mat-option>
    </mat-select>
  </mat-form-field>
  </div>
</div>  -->

<div [dir]="direction">
<header></header>
<div id="page-container">
  <div id="content-wrap">
    <router-outlet></router-outlet>
  </div>
  <footer id="footer"></footer>
</div>
</div>


<!-- <div [dir]="direction" style="position: relative;" style="height: 100%;" class="all-page">


  <div style="position: relative;">
     <header></header>
  </div>
  <div style="position: relative; min-height: 400px; ">
     <router-outlet></router-outlet>
  </div>

  <div style="position: relative;">
     <footer></footer>
  </div>

</div> -->

